export default "__VITE_ASSET__DJwBYpuu__"